import { render } from "./ContractManagementPage.vue?vue&type=template&id=f1c34bc2"
import script from "./ContractManagementPage.vue?vue&type=script&lang=js"
export * from "./ContractManagementPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__